/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   City guide city bizos
 */

import { Bizo, autoclass } from './base'
import type { CityGuideCity as CityGuideCityType, RawCityGuideCity } from './cityGuideCity.types'

export const CityGuideCity: typeof CityGuideCityType = autoclass<
  CityGuideCityType,
  RawCityGuideCity
>('CityGuideCity', class CityGuideCity extends Bizo<CityGuideCityType, RawCityGuideCity> {}, {
  articles: 'articles',
  content: 'content',
  censusData: 'census_data',
  costOfLiving: 'cost_of_living',
  industries: 'industries',
  pois: 'pois',
  survey: 'survey',
  topEmployers: 'top_employers',
  transportation: 'transportation',
  transportationSupplemental: 'transportation_supplemental',
})

export type CityGuideCity = CityGuideCityType
